"use client";

interface VolumeSliderProps {
  value: number;
  onChange: (v: number) => void;
}

export function VolumeSlider({ value, onChange }: VolumeSliderProps) {
  return (
    <div className="flex items-center w-full">
      <div
        className="relative flex-1 h-3 flex items-center cursor-pointer"
        onPointerDown={(e) => {
          e.preventDefault();
          const rect = e.currentTarget.getBoundingClientRect();
          const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          onChange(Math.round(ratio * 100));
          (e.target as HTMLElement).setPointerCapture(e.pointerId);
        }}
        onPointerMove={(e) => {
          if (e.buttons === 0) return;
          const rect = e.currentTarget.getBoundingClientRect();
          const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          onChange(Math.round(ratio * 100));
        }}
      >
        <div className="absolute left-0 right-0 h-[3px] rounded-full bg-bg-elevated">
          <div
            className="absolute left-0 top-0 bottom-0 rounded-full"
            style={{
              width: `${value}%`,
              backgroundColor: "rgba(255, 255, 255, 0.25)",
            }}
          />
        </div>
        <div
          className="absolute w-2 h-2 rounded-full -translate-x-1/2"
          style={{
            left: `${value}%`,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          }}
        />
      </div>
    </div>
  );
}
